/*
 * Copyright Evollis 2022
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { TENANTS } from "../../../constants"
import { loc } from "../../../core/utils"
import Bloc from "./Bloc"
import Field from "./Field"
import React from "react"

export default function BankCoordinatesBloc({
  tunnelData,
  configuration,
  values
}) {
  const { bankCoordinates } = configuration
  const ibanLabel =
    tunnelData.tenant === TENANTS.BPLS ? loc`IBAN bpls` : loc`IBAN`
  const bankLabel =
    tunnelData.tenant === TENANTS.BPLS ? loc`Company bank details` : loc`Bank`

  return (
    <Bloc hide={!bankCoordinates} name={bankLabel}>
      <Field
        hide={!bankCoordinates?.includes("ownerName")}
        name={"Bank account owner"}
        value={values.bankCoordinates.ownerName}
      />
      <Field
        hide={!bankCoordinates?.includes("iban")}
        name={ibanLabel}
        value={values.bankCoordinates.iban}
      />
    </Bloc>
  )
}
